import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.css']
})
export class EditUserModalComponent implements OnInit {

  @Input() user: any
  @Input() canEditRole = true

  @Output() onClose = new EventEmitter<void>()
  @Output() onSave = new EventEmitter<any>()

  name = ''
  roleId = 2

  ngOnInit(): void {
    if (this.user) {
      this.name = this.user.name || ''
      this.roleId = this.user.roleId !== undefined && this.user.roleId !== null ? this.user.roleId : 2
    }
  }

  guardar(): void {
    if (!this.name || !this.name.trim()) return

    this.onSave.emit({ name: this.name, roleId: Number(this.roleId) })
  }

  cerrar(): void {
    this.onClose.emit()
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-user-modal/edit-user-modal.component.ts